import styles from "./ValidationErrors.module.css";
import MultiLanTxt from "../MultiLanTxt/MultiLanTxt";
import { ReactComponent as InvalidIcon } from "../../../images/icons/forms/invalidIcon.svg";

const ValidationErrors = ({ message, validity }) => {
  // console.log("message?.props?.tid", message);
  return (
    <p
      className={[
        "invalidinputPLabel",
        "pLabelPlaceholder",
        styles.validationErrorText,
        validity || validity === undefined ? styles.hide : styles.show,
      ].join(" ")}
    >
      {!validity && <InvalidIcon fontSize="small" />}
      {/* {message} */}
      {/* <MultiLanTxt tid={message?.props?.tid} /> */}
      {/* {message?.props?.tid ? <MultiLanTxt tid={message?.props?.tid} /> : ""} */}
      {Array.isArray(message) ? (
        message.map((eachMsg, index) => <MultiLanTxt tid={eachMsg} key={`${eachMsg} temp ${index}`} />)
      ) : message?.props?.tid ? (
        <MultiLanTxt tid={message?.props?.tid} />
      ) : (
        message
      )}
    </p>
  );
};

export default ValidationErrors;
